export type Block =
  | { type: 'h2'; text: string }
  | { type: 'p'; text: string }
  | { type: 'ul'; items: string[] }
  | { type: 'cta'; title: string; text: string }

export type CategorySlug = 'cost-planning' | 'construction-technical' | 'design-types'

export interface Category {
  slug: CategorySlug
  name: string
  description: string
}

export interface Post {
  slug: string
  title: string
  metaTitle: string
  description: string
  excerpt: string
  category: CategorySlug
  image: string
  imageAlt: string
  datePublished: string
  dateModified: string
  readMinutes: number
  blocks: Block[]
}

export const CATEGORIES: Category[] = [
  {
    slug: 'cost-planning',
    name: 'Cost & Planning',
    description: 'Budgets, price ranges, permits and the paperwork that comes before you build a dormer.',
  },
  {
    slug: 'construction-technical',
    name: 'Construction & Technical',
    description: 'Framing, roof geometry, insulation and building regulations explained in plain language.',
  },
  {
    slug: 'design-types',
    name: 'Design & Types',
    description: 'Shed, gable, hip and flat dormers compared, with advice on picking the right style.',
  },
]
